import { render, staticRenderFns } from "./communityteacherDetail.vue?vue&type=template&id=0e24ff66&"
import script from "./communityteacherDetail.vue?vue&type=script&lang=js&"
export * from "./communityteacherDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports